const PARENT_SELECTOR = '.js-items-parent';

const createFilter = (parentEl) => {
	const filtersContainer = parentEl.querySelector('.js-filters');
	const items = Array.from(parentEl.querySelectorAll('.js-item'));
	let filteredItems = items;
	const loadMoreBtn = parentEl.querySelector('.js-load-more');
	if (!loadMoreBtn) return;

	let count = parseInt(loadMoreBtn.dataset.count, 10);
	let activeFilterEl;

	if (filtersContainer) {
		const filterItems = Array.from(filtersContainer.querySelectorAll('.js-filter'));
		activeFilterEl = filterItems[0];
		const filterByType = (element) => {
			element.addEventListener('click', () => {
				count = parseInt(loadMoreBtn.dataset.count, 10);
				activeFilterEl.classList.remove('is-active');
				activeFilterEl = element;
				const activeFilter = element.dataset.filter;
				element.classList.add('is-active');
				if (activeFilter === 'all') {
					filteredItems = items;
				}
				else {
					filteredItems = [];
					items.forEach(item => {
						item.style.display = 'none';
					});
					items.forEach(item => {
						const itemFilter = item.dataset.filter;
						if (itemFilter === activeFilter) {
							filteredItems.push(item);
						}
					});
				}
				updateItemDisplay();
			});
		};
		filterItems.forEach(filterByType);
	}

	function updateItemDisplay() {
		loadMoreBtn.style.display = count >= filteredItems.length ? 'none' : 'flex';
		filteredItems.forEach((item, index) => {
			item.style.display = index < count ? 'block' : 'none';
		});
	}

	loadMoreBtn.addEventListener('click', () => {
		count += parseInt(loadMoreBtn.dataset.count, 10);
		updateItemDisplay();
	});

	updateItemDisplay();
};

export const initFilters = () => {
	const filterContainers = document.querySelectorAll(PARENT_SELECTOR);
	if (filterContainers.length === 0) return;

	filterContainers.forEach(createFilter);
};
